import { useParams } from 'react-router-dom';
import { React, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import UserContext from '../../components/User_Context.js';
import * as api from "../../api/apiConnector.js";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import color_bars from "../../assets/images/SMPTE_Color_Bars_16x9.svg";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as menu from "../../assets/menus/menu.js";

const Meet_Screen = (params) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [meets, setMeets] = useState([]);
    const [meet, setMeet] = useState(null);
    const [screenShot, setScreenShot] = useState(null);
    const [clientId, setClientId] = useState(null);
    const { currentUser } = useContext(UserContext);


    //#region meets
    const _refreshMeetsTime = () => {
        const _cells = window.$("span[data-start-time]").toArray();
        for (var c of _cells) {
            c = window.$(c);
            let _date = new Date(c.attr("data-start-time"));
            const _timeFromDate = new Date().getTime() - _date.getTime();

            const _days = Math.floor(_timeFromDate / (1000 * 60 * 60 * 24));
            const _hours = Math.floor((_timeFromDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const _minutes = Math.floor((_timeFromDate % (1000 * 60 * 60)) / (1000 * 60));
            const _seconds = Math.floor((_timeFromDate % (1000 * 60)) / 1000);

            const _string = `${_hours < 10 ? "0" : ""}${_hours}:${_minutes < 10 ? "0" : ""}${_minutes}:${_seconds < 10 ? "0" : ""}${_seconds}`;

            c.text(_string);
        }
    }

    const _drawMeetsTable = ({ meets }) => {
        return (
            <table className="table">
                <thead>
                    <th scope="col">{t('type', { ns: 'labels' })}</th>
                    <th scope="col">{t('url', { ns: 'labels' })}</th>
                    <th scope="col">{t('time', { ns: 'labels' })}</th>
                    <th scope="col"></th>
                </thead>
                <tbody>
                    {_drawMeetsRows({ meets })}
                </tbody>
            </table>
        );
    }

    const _drawMeetsRows = ({ meets }) => {
        return (meets.map((meet) => {
            return _drawMeetRow({ meet })
        }));
    }

    const _drawMeetRow = ({ meet }) => {
        const _link = `/meet/${meet.id}`;

        return (<tr>
            <td><a href={_link}>{meet.type}</a></td>
            <td><a href={_link}>{meet.url}</a></td>
            <td><a href={_link}><span data-start-time={meet.start_time.toISOString()}></span></a></td>
            <td></td>
        </tr>);
    }

    const _request_new_meet = async (params) => {
        withReactContent(Swal).fire({
            title: t('joinMeetTitle', { ns: 'labels' }),
            icon: "info",
            html: `
                <div class="form-group">
                    <label>
                        ${t('joinMeetLabel', { ns: 'labels' })}                     
                       
                    </label>
                     <input type="url" id="new-meet-url" class="form-control"></input>
                </div>
                <div>
                <small class="form-text text-muted">${t('meetPlatformsHelper', { ns: 'labels' })}</small>
                </div>
            `,
            preConfirm: (e) => {
                const _url = window.$("#new-meet-url").val();

                if (_url) {
                    _sendMessage({
                        type: "start_meet",
                        url: _url
                    });

                    withReactContent(Swal).fire({
                        title: t('aiRecordingTitle', { ns: 'labels' }),
                        icon: "info",
                        text: t('aiRecordingMessage', { ns: 'labels' }),
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                }

            },
            showConfirmButton: true,
            showCancelButton: true
        });
    }
    //#endregion

    //#region icomm
    const _sendMessage = async (message) => {
        if (id) {
            message.meet = id;
        }

        const result = await api.sendMessage("meet/monitor/message", {
            user: currentUser(),
            body: {
                message,
                id: window.client.id
            }
        });
    }

    const _parseMessage = async (message) => {
        if (!message || !message.type) return;

        if (message.meets) {
            message.meets.forEach((m) => {
                m.start_time = m.start_time ? new Date(m.start_time) : null;
            });
            window.meets = message.meets;
            setMeets(window.meets);
        }

        if (message.meet) {
            message.meet.start_time = message.meet.start_time ? new Date(message.meet.start_time) : null;
            setMeet(message.meet);
        }


        switch (message.type) {
            case "stopping": {
                window.document.location.href = '/';
            }
                break;
            case "still_there": {
                withReactContent(Swal).fire({
                    title: t('stillThereTitle', { ns: 'labels' }),
                    icon: "question",
                    text: t('stillThereMessage', { ns: 'labels' }),
                    showConfirmButton: true,

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        _sendMessage({
                            type: "ping"
                        });
                    } else {
                        window.document.location.href = '/';
                    }
                });
            }
                break;
            case "meet_event": {
                switch (message.event.type) {
                    case "screen_shot": {
                        setScreenShot(message.event.data);
                    }
                        break;
                    case "status_update": {
                        switch (message.event.data) {
                            case "finished": {
                                withReactContent(Swal).fire({
                                    title: t('meetTitle', { ns: 'labels' }),
                                    icon: "info",
                                    text: t('meetConcludedMessage', { ns: 'labels' }),
                                    showConfirmButton: true
                                }).then((x) => {
                                    window.location.href = "/meet";
                                });
                            }
                                break;
                        }
                    }
                        break;
                }

            }
                break;
            case "wellcome": {
                window.client.id = message.id;

                _sendMessage({
                    type: "authenticate",
                    token: currentUser().token,
                    meet: id
                });
            }
                break;
            case "authenticated": {
                if (id && !message.meet) {
                    withReactContent(Swal).fire({
                        title: t('meetTitle', { ns: 'labels' }),
                        icon: "info",
                        text: t('meetConcludedMessage', { ns: 'labels' }),
                        showConfirmButton: true
                    }).then((x) => {
                        window.location.href = "/meet";
                    });
                }
            }
        }
    }

    const _connect = async () => {
        if (!window.client) {
            const _client = new window.EventSource(`${process.env.REACT_APP_API_URL}/meet/monitor`);
            _client.onmessage = (e) => {
                _parseMessage(JSON.parse(e.data));
            }

            window.client = {
                emitter: _client
            }

            return _client;
        }
    }
    //#endregion

    //#region screen logic
    const _draw = () => {
        if (id) {
            if (meet) {
                return (<>
                    <div class="page-titles">
                        <ol class="breadcrumb">
                        </ol>

                        <div>
                            <a class="text-primary " onClick={async (e) => {
                                window.location.href = "/meet";
                            }} role="button" title={t('meetsMonitorTooltip', { ns: 'labels' })}><i class="fa-solid fa-list fa-2x"></i>
                            </a>
                        </div>

                    </div>
                    <div className="row">
                        <div class="col-xl-12">
                            <div class="card">
                                <div class="card-body "></div>
                                <div class="active-projects task-table table-responsive">
                                    <div class="tbl-caption">
                                        <h4 class="heading mb-0">{meet.type} {meet.start_time.toLocaleDateString()}</h4>
                                        <small>{meet.url}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body p-0">

                                    <div className="container">
                                        <div className="row">
                                            <div className="col-4">
                                                {t('startedAt', { ns: 'labels' })}
                                            </div>
                                            <div className="col-6">
                                                {meet.start_time.toLocaleDateString()} {meet.start_time.toLocaleTimeString()}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div className="col-4">
                                                {t('url', { ns: 'labels' })}
                                            </div>
                                            <div className="col-6">
                                                {meet.url}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div className="col-4">
                                                {t('status', { ns: 'labels' })}
                                            </div>
                                            <div className="col-6">
                                                {meet.status} (<a className="text-primary" href="javascript: void(0)"
                                                    onClick={(e) => {
                                                        withReactContent(Swal).fire({
                                                            title: t('meetTitle', { ns: 'labels' }),
                                                            icon: "alert",
                                                            text: t('stopRecordingConfirm', { ns: 'labels' }),
                                                            showConfirmButton: true,
                                                            showCancelButton: true
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                _sendMessage({
                                                                    type: "stop_meet"
                                                                });

                                                                setTimeout(() => {
                                                                    window.location.href = `/`;
                                                                }, 3000);
                                                            }
                                                        });
                                                    }}
                                                >{t('stopRecording', { ns: 'labels' })}</a>)
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div className="col-4">
                                                {t('participants', { ns: 'labels' })}
                                            </div>
                                            <div className="col-6">
                                                {meet.partecipantsCount}
                                            </div>
                                        </div>
                                    </div>
                                    <hr />

                                    <div style={{
                                        textAlign: "center"
                                    }}>
                                        {screenShot ? (
                                            <img style={{ width: "75%" }} src={`data:image/jpeg;base64, ${screenShot}`} className="rounded img-fluid"></img>
                                        ) : (<img style={{ width: "75%" }} src={color_bars} className="rounded img-fluid"></img>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>);
            }
        }
        else {
            return (
                <>
                    <div class="page-titles">
                        <ol class="breadcrumb">
                        </ol>

                        <div>
                            <a class="text-primary " onClick={async (e) => {
                                _request_new_meet();
                            }} role="button" title={t('joinMeetTooltip', { ns: 'labels' })}><i class="fa-solid fa-plus fa-2x"></i>
                            </a>
                        </div>

                    </div>
                    <div className="row">
                        <div class="col-xl-12">
                            <div class="card">
                                <div class="card-body "></div>
                                <div class="active-projects task-table">
                                    <div class="tbl-caption">
                                        <h4 class="heading mb-0">{t('activeMeetsTitle', { ns: 'labels' })}</h4>
                                        <small>{t('activeMeetsDescription', { ns: 'labels' })}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12">
                        <div class="card">
                            <div class="card-body p-0">
                                <div class="table-responsive active-projects task-table">
                                    <div class="tbl-caption">
                                        {_drawMeetsTable({ meets })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
    //#endregion

    useEffect(() => {
        (async () => {
            breadcrumb.set([{
                name: t('home', { ns: 'labels' }),
                link: "/"
            },
            {
                name: t('meet', { ns: 'labels' }),
                link: "/meet"
            }
            ]);
            menu.write({ user: currentUser() });
            _connect();
            setInterval(() => {
                _refreshMeetsTime();
            }, 1000);
        })();
    }, []);

    useEffect(() => {
        (async () => {

        })();
    }, [meets]);

    useEffect(() => {
        (async () => {
            if (meet && !id) {
                window.location.href = `/meet/${meet.id}`;
            }

            if (meet) {
                breadcrumb.set([{
                    name: t('home', { ns: 'labels' }),
                    link: "/"
                },
                {
                    name: t('meet', { ns: 'labels' }),
                    link: "/meet"
                },
                {
                    name: `${meet.type} ${meet.start_time.toLocaleDateString()} ${meet.start_time.toLocaleTimeString()}`,
                    link: `/meet/${meet.id}`
                }
                ]);
            }
        })();
    }, [meet]);

    return (<>
        {_draw()}
    </>
    );
}

export { Meet_Screen }